import { makeRequest } from "./general";

const apiAdditionalServiceUrl = window.apiAdditionalServiceUrl;
export default class AdditionalServices {
  constructor() {
    this.baseUrl = apiAdditionalServiceUrl;
  }

  async serviciosPorProducto(codigoProducto, documento) {
    const url = `${this.baseUrl}/api/ProductoServicio/${codigoProducto}?cedula=${documento}`;
    const params = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    return await makeRequest(url, params);
  }
}
